import type { FC } from "react";
import RedFlag from "../../../assets/Icon-Red_Hat-Flag-A-Red-RGB.png";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import { PARTNER_SALES_HOMEPAGE_LINK } from "../../../constants/DashBoardUrls";
import { DashboardCard } from "../shared/DashboardCard";

export const SalesAndBusinessPartners: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({
	dragHandleProps,
}) => (
	<DashboardCard
		title="Sales Opportunities"
		description="Register deals, manage your sales and view your partner program status on our new sales platform."
		subtext="Currently limited to resellers, distributors and sell-with partners."
		icon={RedFlag}
		primaryAction={{
			label: "Register an opportunity",
			href: "https://partners.connect.redhat.com/s/register-deal-reg-opportunity",
		}}
		footerLinks={[{ label: "View Sales Homepage", href: PARTNER_SALES_HOMEPAGE_LINK }]}
		dragHandleProps={dragHandleProps}
	/>
);
